import React from 'react';
import { TextField  } from '@contentful/forma-36-react-components';
import '@contentful/forma-36-react-components/dist/styles.css';
import { EditorExtensionSDK } from 'contentful-ui-extensions-sdk';

interface EditorProps {
  sdk: EditorExtensionSDK;
} 

const Entry = (props: EditorProps) => {
  console.log("sda")

  return <TextField >Hello Entry Editor Component</TextField >;
};

export default Entry;
